




































































































































































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import Paging from 'biz-ts/src/api/Paging';
import Firmware, {firmwareStatusZh} from "@/model/Firmware";
import PaginationTable from "@/component/Table/pagination-table.vue";
import FirmwareApi from "@/module/device/FirmwareApi";
import {FcreateForm, FpqForm} from "@/form/FirmwareForm";
import productModule from "@/store/module/ProductModule";
import RefreshButton from "@/component/Button/refresh-button.vue";
import CreateDialog from "@/component/Crud/create-dialog.vue";
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import ConfirmDialog from "@/component/Dialog/confirm-dialog.vue";
import WarnDialog from "@/component/Dialog/warn-dialog.vue";
import FirmwareConfigApi from "@/module/device/FirmwareConfigApi";
import ConfigButton from "@/component/Button/config-button.vue";
import EditDialog from "@/component/Crud/edit-dialog.vue";
import {FconfigEditForm} from '@/form/FirmwareConfigForm';
import {qerr} from "tools-ts/src/error/QuietError";
import FirmwareConfig from "@/model/FirmwareConfig";
import {Form, Upload} from "element-ui";
import {HttpRequestOptions} from "element-ui/types/upload";
import {ElFile} from "@/ext/element-ui/ElFile";
import _ from 'lodash';

@Component({
  components: {
    EditDialog,
    ConfigButton,
    RefreshButton,
    PaginationTable,
    CreateDialog,
    DeleteDialog,
    ConfirmDialog,
    WarnDialog,
  },
})
export default class FirmwareView extends Vue {

  private firmwareApi = Container.get(FirmwareApi)

  private firmwareStatusZh = firmwareStatusZh

  @Ref()
  private ptable!: PaginationTable

  private paging = new Paging<Firmware>()
  private pqForm = new FpqForm(this.product.id)

  private get product() {
    return productModule.active
  }

  private refresh() {
    this.ptable?.refresh()
  }

  private async getPaging() {
    return this.firmwareApi.paging(this.pqForm)
  }

  private statusFmt(firmware: Firmware) {
    return this.firmwareStatusZh[firmware.status]
  }

  @Ref()
  private createDialog!: CreateDialog

  @Ref()
  private createElForm!: Form

  @Ref()
  private uploader!: Upload

  private createForm = new FcreateForm(this.product.id)

  private async beforeOpenCreateForm() {
    this.createElForm?.resetFields()
    this.uploader?.clearFiles()
    this.createForm.init(this.product.id)
    await this.requestDir()
  }

  private createRules =
      {
        version: [
          {required: true, message: '请输入固件版本', trigger: ['change', 'blur']},
          {min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'change'}
        ],
        file: [
          {required: true, message: '请选择文件', trigger: ''}
        ],
      }

  private handleFirmwareChange(file: ElFile) {
    const filename = file.name
    switch (file.status) {
      case "ready":
        this.createForm.file = file
        if (this.createForm.name == undefined)
          this.createForm.name = filename
        break
    }
    if (!_.isEmpty(filename))
      this.createForm.version = filename.replace(/\.bin$/, "")
    this.createElForm.validateField("file")
  }

  private handleFirmwareRemove() {
    this.createForm.file = undefined
    this.createForm.name = undefined
    this.createElForm.validateField("file")
  }

  private handleCreateClick() {
    this.createElForm.validate(valid => {
      if (valid)
        this.uploader?.submit()
      else
        throw qerr()
    })
  }

  private async createFirmware(options: HttpRequestOptions) {
    this.createForm.file = options.file
    await this.firmwareApi.create(this.createForm)
    this.refresh()
  }

  private handleCreateError(err: object) {
    return Promise.reject(err)
  }

  private firmware = new Firmware()

  @Ref()
  private publishDialog!: ConfirmDialog

  private handlePublishClick(firmware: Firmware) {
    this.firmware = firmware
    this.publishDialog.open()
  }

  private async publishFirmware() {
    await this.firmwareApi.publish(this.firmware.id)
  }

  @Ref()
  private deleteDialog!: DeleteDialog

  private handleDeleteClick(firmware: Firmware) {
    this.firmware = firmware
    this.deleteDialog.open()
  }

  private async deleteFirmware() {
    await this.firmwareApi.delete(this.firmware.id)
  }

  @Ref()
  private unusualDialog!: WarnDialog

  private handleUnusualClick(firmware: Firmware) {
    this.firmware = firmware
    this.unusualDialog.open()
  }

  private async unusualFirmware() {
    await this.firmwareApi.unusual(this.firmware.id)
  }

  private fconfigApi = Container.get(FirmwareConfigApi)

  private fconfig = new FirmwareConfig()

  @Ref()
  private configEditDialog!: EditDialog

  private configEditForm = new FconfigEditForm()

  private async getConfig() {
    this.fconfig = await this.fconfigApi.query(this.product.id)
  }

  private async beforeOpenConfigEditForm() {
    await this.getConfig()
    this.configEditForm.init(this.fconfig)
  }

  private async editConfig() {
    await this.fconfigApi.edit(this.configEditForm)
  }

  private async requestDir() {
    await this.getConfig()
    if (this.fconfig.dir == undefined) {
      await this.configEditDialog.open()
      this.$message.error("必须先设置固件保存目录")
      throw qerr()
    }
  }
}
